module.exports = __webpack_public_path__ + "static/altana-daleko_thumb-bd15a94366dc5fd236c535b1f04699a0.jpg";